import {Pipe, PipeTransform} from '@angular/core';
import {formatNumber} from "@angular/common";
import {DEFAULT_DIGITS_INFO, DEFAULT_LOCALE} from "../../utils/constants";

@Pipe({
  name: 'loyaltyNumber'
})
export class LoyaltyNumberPipe implements PipeTransform {

  transform(value: number | null | undefined,
            locale: string = DEFAULT_LOCALE,
            digitsInfo: string = DEFAULT_DIGITS_INFO): string {
    return loyaltyFormatNumber(value, locale, digitsInfo);
  }
}

export function loyaltyFormatNumber(value: number | null | undefined,
                                    locale: string = DEFAULT_LOCALE,
                                    digitsInfo: string = DEFAULT_DIGITS_INFO): string {
  return formatNumber(value ?? 0, locale, digitsInfo);
}
